import { DbMetricsResponse } from "../services/NetworkClient/BackendAPIs/AdminAPIHandler";
import { ErrorLogger } from "./Logger";

class AdminLocalStorageManager {
  private static instance: AdminLocalStorageManager;
  private readonly METRICS_KEY = "admin_db_metrics";

  private constructor() {}

  public static getInstance(): AdminLocalStorageManager {
    if (!AdminLocalStorageManager.instance) {
      AdminLocalStorageManager.instance = new AdminLocalStorageManager();
    }
    return AdminLocalStorageManager.instance;
  }

  /**
   * Save metrics data to localStorage with base64 encoding
   */
  public saveMetrics(metrics: DbMetricsResponse): void {
    try {
      const jsonString = JSON.stringify(metrics);
      const base64Data = btoa(jsonString);
      localStorage.setItem(this.METRICS_KEY, base64Data);
    } catch (error) {
      ErrorLogger.log(error, 'AdminLocalStorageManager.saveMetrics');
    }
  }

  /**
   * Retrieve metrics data from localStorage with base64 decoding
   */
  public getMetrics(): DbMetricsResponse | null {
    try {
      const base64Data = localStorage.getItem(this.METRICS_KEY);
      if (!base64Data) {
        return null;
      }

      const jsonString = atob(base64Data);
      const metrics: DbMetricsResponse = JSON.parse(jsonString);
      return metrics;
    } catch (error) {
      ErrorLogger.log(error, 'AdminLocalStorageManager.getMetrics');
      // Clear corrupted data
      this.clearMetrics();
      return null;
    }
  }

  /**
   * Clear metrics data from localStorage
   */
  public clearMetrics(): void {
    try {
      localStorage.removeItem(this.METRICS_KEY);
    } catch (error) {
      ErrorLogger.log(error, 'AdminLocalStorageManager.clearMetrics');
    }
  }

  /**
   * Check if metrics data exists in localStorage
   */
  public hasMetrics(): boolean {
    return localStorage.getItem(this.METRICS_KEY) !== null;
  }
}

// Export singleton instance
export const adminLocalStorageManager = AdminLocalStorageManager.getInstance();
